import type {
    FileIconThemeManifest,
    ProductIconThemeManifest,
} from "../../contracts";
import type { ProductIconSlotId } from "../../registry/icon-slot-registry";

export const BUILTIN_PRODUCT_ICON_THEMES: Array<
    ProductIconThemeManifest<ProductIconSlotId>
> = [
        {
            id: "magicmd.default-product-icons",
            label: "Default Product Icons",
            icons: {
                "sidebar.files": { name: "FolderOpen" },
                "sidebar.explorer": { name: "FolderTree" },
                "sidebar.search": { name: "Search" },
                "sidebar.toc": { name: "List" },
                "sidebar.plugins": { name: "Puzzle" },
                "sidebar.extension": { name: "BotMessageSquare" },
                "sidebar.publish": { name: "Upload" },
                "sidebar.engine": { name: "Cpu" },
                "tab.file": { name: "FileText" },
                "tab.close": { name: "X" },
                "status.execution": { name: "Blocks" },
                "status.engine": { name: "Server" },
                "status.logs": { name: "Terminal" },
                "status.mcp": { name: "Plug" },
                "status.sessions": { name: "Layers" },
                "status.sidecars": { name: "Cpu" },
            },
        },
        {
            id: "magicmd.minimal-product-icons",
            label: "Minimal Product Icons",
            icons: {
                "sidebar.files": { name: "FileText" },
                "sidebar.explorer": { name: "Folder" },
                "sidebar.search": { name: "Search" },
                "sidebar.toc": { name: "Blocks" },
                "sidebar.plugins": { name: "Box" },
                "sidebar.extension": { name: "BotMessageSquare" },
                "sidebar.publish": { name: "Send" },
                "sidebar.engine": { name: "ServerCog" },
                "tab.file": { name: "File" },
                "tab.close": { name: "CircleX" },
                "status.execution": { name: "Play" },
                "status.engine": { name: "Cpu" },
                "status.logs": { name: "ListTree" },
                "status.mcp": { name: "PlugZap" },
                "status.sessions": { name: "Layers3" },
                "status.sidecars": { name: "Package" },
            },
        },
    ];

export const BUILTIN_FILE_ICON_THEMES: FileIconThemeManifest[] = [
    {
        id: "magicmd.default-file-icons",
        label: "Default File Icons",
        folders: {
            closed: { name: "Folder", color: "var(--color-muted-foreground)" },
            open: { name: "FolderOpen", color: "var(--color-primary)" },
            workspace: { name: "FolderTree", color: "var(--color-primary)" },
        },
        extensions: {
            md: { name: "FileText", color: "var(--color-info)" },
            markdown: { name: "FileText", color: "var(--color-info)" },
            mdx: { name: "FileText", color: "var(--color-info)" },
            mdspace: { name: "Layers", color: "var(--color-primary)" },
            json: { name: "Braces", color: "var(--cm-ref-scope)" },
            yml: { name: "FileJson2", color: "var(--cm-meta-accent)" },
            yaml: { name: "FileJson2", color: "var(--cm-meta-accent)" },
            png: { name: "Image", color: "var(--cm-render-accent)" },
            jpg: { name: "Image", color: "var(--cm-render-accent)" },
            jpeg: { name: "Image", color: "var(--cm-render-accent)" },
        },
        exactNames: {
            "package.json": { name: "Package2", color: "var(--cm-import-accent)" },
            "tsconfig.json": { name: "FileJson2", color: "var(--cm-ref-scope)" },
        },
        fallbackFile: {
            name: "File",
            color: "var(--color-muted-foreground)",
        },
    },
    {
        id: "magicmd.minimal-file-icons",
        label: "Minimal File Icons",
        folders: {
            closed: { name: "FolderClosed", color: "var(--color-muted-foreground)" },
            open: { name: "FolderOpen", color: "var(--color-muted-foreground)" },
            workspace: { name: "Folder", color: "var(--color-muted-foreground)" },
        },
        extensions: {
            md: { name: "File", color: "var(--color-muted-foreground)" },
            markdown: { name: "File", color: "var(--color-muted-foreground)" },
            mdx: { name: "File", color: "var(--color-muted-foreground)" },
            mdspace: { name: "Layers", color: "var(--color-muted-foreground)" },
            json: { name: "FileJson2", color: "var(--color-muted-foreground)" },
            yml: { name: "FileJson2", color: "var(--color-muted-foreground)" },
            yaml: { name: "FileJson2", color: "var(--color-muted-foreground)" },
            png: { name: "Image", color: "var(--color-muted-foreground)" },
            jpg: { name: "Image", color: "var(--color-muted-foreground)" },
            jpeg: { name: "Image", color: "var(--color-muted-foreground)" },
        },
        exactNames: {
            "package.json": { name: "FileJson2", color: "var(--color-muted-foreground)" },
            "tsconfig.json": { name: "FileJson2", color: "var(--color-muted-foreground)" },
        },
        fallbackFile: {
            name: "File",
            color: "var(--color-muted-foreground)",
        },
    },
];
